var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h2',{staticClass:"step-title"},[_c('span',[_vm._v(_vm._s(_vm.$t('step', { n: _vm.step })))])]),_c('br'),_c('bank-details-form',{attrs:{"bankDetails":_vm.bankDetails,"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }